// Mock data for the Font Style Selection page

export const mockRootProps = {
  fontStyles: [
    {
      id: 'modern',
      name: 'Modern',
      fontFamily: 'Poppins, sans-serif',
      selected: true
    },
    {
      id: 'elegant', 
      name: 'Elegant',
      fontFamily: 'Open Sans, sans-serif',
      selected: false
    },
    {
      id: 'slab',
      name: 'Slab',
      fontFamily: 'Nunito Sans, sans-serif',
      selected: false
    },
    {
      id: 'handwritten',
      name: 'Hand Written',
      fontFamily: 'Montserrat, sans-serif',
      selected: false
    },
    {
      id: 'playful',
      name: 'Playful',
      fontFamily: 'Inter, sans-serif',
      selected: false
    },
    {
      id: 'futuristic',
      name: 'Futuristic',
      fontFamily: 'Roboto, sans-serif',
      selected: false
    }
  ]
};